const API_URL = 'https://vatikaindianrestaurant.com.au/csadmin/api/'


const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting };